export default __webpack_public_path__ + "static/media/ike-komcare.07891302.ico";